<template>
  <div>
    <b-card no-body>
      <b-card-header>
        <b-card-title class="d-flex align-items-end w-100 justify-content-between">
          Sadaka Verenler Raporu
          <b-card-sub-title
            class="font-medium-2 badge badge-light-warning px-1 badge-pill"
            sub-title-text-variant="white"
          >
            {{ month }} {{ year }}
          </b-card-sub-title>
        </b-card-title>
      </b-card-header>
      <b-table-simple
        responsive
        striped
        bordered
        class="mb-0"
      >
        <b-thead>
          <b-tr>
            <b-th class="width-100 text-nowrap">
              İşlem Tarihi
            </b-th>
            <b-th>
              Açıklama
            </b-th>
            <b-th class="width-100 text-nowrap text-center">
              Makbuz
            </b-th>
            <b-th class="width-200 text-nowrap">
              Banka / Kasa
            </b-th>
            <b-th class="width-200 text-nowrap text-right">
              Toplam Tutar
            </b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <template
            v-for="(item,index) in sadakaList.data"
          >
            <b-tr :key="index">
              <b-td>
                {{ moment(item.ddate).format('DD.MM.YYYY') }}
              </b-td>
              <b-td>
                {{ item.notes }}
              </b-td>
              <b-td class="text-center">
                <b-badge
                  :variant="item.is_receipt === '1'? 'light-success' : 'light-danger'"
                  pill
                >
                  <FeatherIcon :icon="item.is_receipt === '1'? 'CheckCircleIcon' : 'XCircleIcon'" />
                </b-badge>
              </b-td>
              <b-td>
                <template v-if="item.safe">
                  <div class="font-small-3 text-danger">
                    Kasa
                  </div>
                  <div class="text-danger font-small-3 font-weight-bold">
                    {{ item.safe }}
                  </div>
                </template>
                <template v-else>
                  <div class="font-small-3 text-primary">
                    Kasa
                  </div>
                  <div class="text-primary font-small-3 font-weight-bold">
                    {{ item.bank_account }}
                  </div>
                </template>
              </b-td>
              <b-th class="text-right">
                {{ item.amount | toCurrency }} TL
              </b-th>
            </b-tr>
          </template>
        </b-tbody>
        <b-tfoot>
          <b-tr>
            <b-th colspan="4">
              Genel Toplam
            </b-th>
            <b-th class="text-right">
              {{ sadakaList.grandTotal | toCurrency }} TL
            </b-th>
          </b-tr>
        </b-tfoot>
      </b-table-simple>
    </b-card>
  </div>
</template>
<script>
import {
  BCard, BTableSimple, BThead, BTbody, BTh, BTd, BTr, BTfoot, BCardHeader, BCardTitle, BCardSubTitle, BBadge,
} from 'bootstrap-vue'

export default {
  name: 'SadakaListReport',
  components: {
    BCard,
    BTableSimple,
    BThead,
    BTbody,
    BTfoot,
    BTh,
    BTd,
    BTr,
    BCardHeader,
    BCardTitle,
    BCardSubTitle,
    BBadge,
  },
  computed: {
    month() {
      return this.$store.getters['directorReports/month']
    },
    year() {
      return this.$store.getters['directorReports/year']
    },
    sadakaList() {
      return this.$store.getters['directorReports/sadakaList']
    },
  },
}
</script>
